import React from 'react';

export default function EarthIcon(props) {
  return (
    <svg width={25} height={25} viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M15.8969 12.5C15.8969 11.3884 15.859 10.2769 15.7958 9.20317C14.7221 9.14001 13.6232 9.10211 12.499 9.10211C11.3748 9.10211 10.2758 9.14001 9.20215 9.20317C9.13899 10.2769 9.10107 11.3758 9.10107 12.5C9.10107 13.6242 9.13899 14.7232 9.20215 15.7969C10.2758 15.86 11.3748 15.8979 12.499 15.8979C13.6232 15.8979 14.7221 15.86 15.7958 15.7969C15.859 14.7232 15.8969 13.6242 15.8969 12.5Z'
        fill='currentColor'
      />
      <path
        d='M0.663118 10.6305C0.562065 11.2369 0.498901 11.8684 0.498901 12.5C0.498901 13.1316 0.562065 13.7632 0.663118 14.3695L0.877833 14.4326C2.49468 14.9379 4.47785 15.3168 6.66312 15.5695C6.61259 14.5716 6.57469 13.5484 6.57469 12.5C6.57469 11.4516 6.61259 10.4284 6.66312 9.43054C4.47785 9.68317 2.48204 10.0621 0.877833 10.5674L0.663118 10.6305Z'
        fill='currentColor'
      />
      <path
        d='M23.5263 7.7758C22.3136 4.95896 20.0526 2.68529 17.2231 1.47266C17.6273 3.07687 17.9305 4.90843 18.1326 6.86633C20.0905 7.06843 21.9221 7.37159 23.5263 7.7758Z'
        fill='currentColor'
      />
      <path
        d='M24.3347 14.3695C24.4357 13.7632 24.4989 13.1316 24.4989 12.5C24.4989 11.8684 24.4357 11.2369 24.3347 10.6305L24.1199 10.5674C22.5031 10.0621 20.5199 9.68317 18.3347 9.43054C18.3852 10.4284 18.4231 11.4516 18.4231 12.5C18.4231 13.5484 18.3852 14.5716 18.3347 15.5695C20.5199 15.3168 22.5157 14.9379 24.1199 14.4326L24.3347 14.3695Z'
        fill='currentColor'
      />
      <path
        d='M23.5263 17.2242C21.9221 17.6284 20.0905 17.9316 18.1326 18.1337C17.9305 20.0916 17.6273 21.9231 17.2231 23.5273C20.0399 22.3147 22.3136 20.0537 23.5263 17.2242Z'
        fill='currentColor'
      />
      <path
        d='M9.4295 18.3358C9.68214 20.521 10.0611 22.5168 10.5663 24.121L10.6295 24.3358C11.2358 24.4368 11.8674 24.5 12.499 24.5C13.1305 24.5 13.7621 24.4368 14.3685 24.3358L14.4316 24.121C14.9369 22.5042 15.3158 20.521 15.5684 18.3358C14.5705 18.3863 13.5474 18.4242 12.499 18.4242C11.4505 18.4242 10.4274 18.3863 9.4295 18.3358Z'
        fill='currentColor'
      />
      <path
        d='M15.5684 6.66422C15.3158 4.47895 14.9369 2.48316 14.4316 0.878951L14.3685 0.664217C13.7621 0.563164 13.1305 0.5 12.499 0.5C11.8674 0.5 11.2358 0.563164 10.6295 0.664217L10.5663 0.878951C10.0611 2.49579 9.68214 4.47895 9.4295 6.66422C10.4274 6.61369 11.4505 6.57579 12.499 6.57579C13.5474 6.57579 14.5705 6.61369 15.5684 6.66422Z'
        fill='currentColor'
      />
      <path
        d='M7.77474 23.5273C7.37053 21.9231 7.06737 20.0916 6.86527 18.1337C4.90737 17.9316 3.07577 17.6284 1.47156 17.2242C2.68419 20.041 4.94527 22.3147 7.77474 23.5273Z'
        fill='currentColor'
      />
      <path
        d='M7.77474 1.47266C4.9579 2.68529 2.68419 4.94633 1.47156 7.7758C3.07577 7.37159 4.90737 7.06843 6.86527 6.86633C7.06737 4.90843 7.37053 3.07687 7.77474 1.47266Z'
        fill='currentColor'
      />
    </svg>
  );
}
